import styled, { css } from "styled-components"
import { Link } from "gatsby"
import { CursorCrosshairBlack } from "shared/Styles/Cursors"

export const NavWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  animation: ${({ duration }) => (duration ? duration : "0.5")}s
    ${({ active }) => (active ? "enter" : "exit")};
  animation-fill-mode: both;

  @keyframes enter {
    from {
      background-color: transparent;
    }
    to {
      background-color: hsla(0, 0%, 45.1%, 0.7);
    }
  }
  @keyframes exit {
    from {
      background-color: hsla(0, 0%, 45.1%, 0.7);
    }
    to {
      background-color: transparent;
    }
  }

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.phoneSmall}) {
    text-align: left;
    justify-content: flex-start;
    padding-left: 12px;
  }
`
const ActiveProperties = css`
  -webkit-text-stroke: 1px;
  -webkit-text-fill-color: transparent;
  color: #ffa290;
`
export const MenuList = styled.ul`
  position: relative;
  transition: all 0.5s ease;
`

export const LinkCss = css`
  ${CursorCrosshairBlack}
  transition: all .5s ease-in-out;
  font-size: 45px;
  color: #fff;
  line-height: 120%;
  text-decoration: none;
  font-family: "sharp_grotesksemibold_25", Arial, Helvetica, sans-serif;
  position: relative;
  overflow: hidden;

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tabletSmall}) {
    font-size: 30px;
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.phoneSmall}) {
    font-size: 24px;
  }
  &:hover {
    ${ActiveProperties}
    &:after {
      width: 100%;
    }
  }
  &.active {
    ${ActiveProperties}
  }
  &:after {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    width: 0%;
    height: 1px;
    background-color: ${({ theme }) => theme.color.primary};
    transition: width 0.3s ease-in-out;
  }
`

export const HoverableLink = styled(Link)`
  ${LinkCss}
`

export const HoverableSpan = styled.span`
  ${LinkCss}
`

export const HoverableAnchor = styled.a`
  ${LinkCss}
`

export const ListElement = styled.li`
  position: relative;
  animation: ${({ show }) => (show ? "enterAnimation" : "exitAnimation")};
  animation-duration: ${({ duration }) => (duration ? duration : "0.5")}s;
  animation-delay: ${({ delay }) => (delay ? delay : "0")}s;
  animation-fill-mode: both;

  @keyframes enterAnimation {
    from {
      opacity: 0;
      top: 150px;
    }
    to {
      opacity: 1;
      top: 0;
    }
  }
  @keyframes exitAnimation {
    from {
      opacity: 1;
      top: 0;
    }
    to {
      opacity: 0;
      top: 150px;
    }
  }
`

export const IndexIndicator = styled.span`
  font-family: "sharp_grotesksemibold_25", Arial, Helvetica, sans-serif;
  position: relative;
  right: -20px;
  top: -26px;
  font-size: 8px;
  color: #f4f4f4;
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tabletSmall}) {
    top: -15px;
    right: -4px;
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.phoneSmall}) {
    top: -10px;
    right: -4px;
  }
`

export const SubMenu = styled.span`
  position: absolute;
  left: 100%;
  bottom: 15px;
  transition: opacity 0.5s ease-in-out, visibility 0.5s linear;
  opacity: ${({ open }) => (open ? "1" : "0")};
  visibility: ${({ open }) => (open ? "visible" : "hidden")};
  a {
    ${CursorCrosshairBlack}
    transition: all .5s ease-in-out;
    font-size: 15px;
    color: #fff;
    text-decoration: none;
    margin-right: 20px;
    font-family: "sharp_grotesksemibold_25", Arial, Helvetica, sans-serif;
    &:hover {
      color: #ffa290;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tabletBig}) {
    left: 90%;
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tabletSmall}) {
    position: relative;
    left: 0%;
    display: block;
    bottom: unset;
    opacity: 1;
    transition: height 0.5s ease-in-out, visibility 0.5s linear;
    height: ${({ open }) => (open ? "100px" : "0")};
    overflow: hidden;
    a {
      display: block;
      margin: ${({ open }) => (open ? "30px" : 0)} 0;
    }
  }

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.phoneSmall}) {
    height: ${({ open }) => (open ? "70px" : "0")};
    a {
      margin: 16px 0;
    }
  }
`
